<template>
	<v-container class="content" fluid>
		<v-layout column>
			<v-flex>
				<h1>CAD Modell anzeigen</h1>
			</v-flex>
			<v-flex xs12 md4>
				<v-text-field
					v-model="suchbegriff"
					placeholder="Suchen nach Teilenummer"
					hint="Teilenummer eingeben um Suche zu starten"
					clearable
					prepend-inner-icon="search"
				></v-text-field>
				<v-progress-linear v-if="dataLoading" color="accent" indeterminate />
			</v-flex>
			<v-flex v-if="article != '' && article != null" class="mt-3">
				<v-layout>
					<v-flex shrink>
						<cad-preview
							:articleId="article.articleId"
							width="300px"
							height="300px"
							:readonly="true"
						></cad-preview>
					</v-flex>
					<v-flex class="pa-3">
						<v-layout column>
							<v-flex>
								<span class="subheading">Blexon Id: {{ article.articleId }}</span>
							</v-flex>
							<v-flex>
								<span class="subheading">{{ article.materialname }}</span>
							</v-flex>
							<v-flex>
								<span class="subheading"
									>LxBxH: {{ article.length | formatDigit }}x{{
										article.width | formatDigit
									}}x{{ article.height | formatDigit }}mm</span
								>
							</v-flex>
							<v-flex>
								<span class="subheading">{{
									getEntgratartAsText(article.entgratart)
								}}</span>
							</v-flex>
							<v-flex v-if="article.hasEngravings">
								<span class="subheading">Gravur</span>
							</v-flex>
							<v-flex v-if="article.featureDtos.length > 0">
								<span
									class="subheading"
									v-for="(feature, index) in article.featureDtos"
									:key="index"
								>
									{{ feature.count }} x {{ feature.formVorlageText }} |
								</span>
							</v-flex>
							<v-flex v-if="article.weldlines.length > 0">
								<span class="subheading">
									{{ article.weldlines.length }} Schweißnähte |
									{{
										article.weldlines.reduce((a, b) => {
											return a + b.corners.length;
										}, 0)
									}}
									Ecken |
									{{ article.weldlines[0].clean ? "verputzt" : "unverputzt" }}
								</span>
							</v-flex>
							<v-flex v-if="article.powderCoatingTreatment != null">
								<span class="subheading">
									RAL
									{{ article.powderCoatingTreatment.powder.surfaceColor.ralCode }}
									|
									{{
										getPowderSides(article.powderCoatingTreatment.treatmentFace)
									}}
									|
									{{
										getPowderStructure(
											article.powderCoatingTreatment.powder.structure
										)
									}}
									|
									{{
										getPowderFinish(
											article.powderCoatingTreatment.powder.finish
										)
									}}
									<span v-if="article.powderCoatingTreatment.hasBaseCoating"
										>&nbsp;|&nbsp;vorgrundiert</span
									>
								</span>
							</v-flex>
						</v-layout>
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex
				v-if="article != '' && article != null && article.parentArticleId != null"
				class="mt-3"
			>
				<h2>Ist Teil von Baugruppe:</h2>
				<v-layout>
					<v-flex shrink>
						<cad-preview
							:articleId="article.parentArticleId"
							width="300px"
							height="300px"
							:readonly="true"
						></cad-preview>
					</v-flex>
					<v-flex class="pa-3">
						<v-layout column>
							<v-flex>
								<span class="subheading"
									>Blexon Id: {{ article.parentArticleId }}</span
								>
							</v-flex>
						</v-layout>
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex v-if="article == ''" class="mt-3"> Kein Teil gefunden </v-flex>
		</v-layout>
	</v-container>
</template>

<script>
import httpClient from "../store/httpClient";
import { debounce } from "debounce";
import CadPreview from "./cadPreviewComponent.vue";
import { translateEntgratartToText } from "../store/types";

export default {
	components: {
		"cad-preview": CadPreview,
	},
	data() {
		return {
			suchboxHint: "",
			suchbegriff: "",
			dataLoading: false,
			article: "",
		};
	},

	mounted() {},
	watch: {
		suchbegriff() {
			if (this.suchbegriff !== null && this.suchbegriff !== "") {
				this.loadArtikel();
			}
		},
	},
	methods: {
		loadArtikel: debounce(async function () {
			try {
				this.dataLoading = true;
				const response = await httpClient().get(
					`api/Artikel/GetArticleById?blexonArtikelId=` + this.suchbegriff
				);
				this.article = response.data;
			} catch (err) {
				console.log(err);
			} finally {
				this.dataLoading = false;
			}
		}, 1000),

		getEntgratartAsText(entgratart) {
			return translateEntgratartToText(entgratart);
		},

		getPowderSides(articleFaceType) {
			switch (articleFaceType) {
				case 0:
					return "Oberseite";
				case 1:
					return "Unterseite";
				case 2:
					return "Beide Seiten";
			}
		},

		getPowderStructure(powderStructure) {
			switch (powderStructure) {
				case 0:
					return "Fein";
				case 1:
					return "Grob";
				case 2:
					return "Glatt";
			}
		},

		getPowderFinish(powderFinish) {
			switch (powderFinish) {
				case 0:
					return "Matt";
				case 1:
					return "Glänzend";
			}
		},
	},
};
</script>
<style>
.v-dialog.specialSize {
	max-height: 100% !important;
	margin: 12px;
}
h1,
h2 {
	font-weight: 300;
}
</style>
